import { GridApi } from "ag-grid-community";
import { Button, Input, Row } from "antd";
import React from "react";

const { Search } = Input;

interface IProps {
  gridApi?: GridApi;
}

export default ({ gridApi }: IProps) => {
  return (
    <Row justify="space-between">
      <Search
        placeholder="quick search..."
        onSearch={value => onSearch(value)}
        onChange={e => onSearch(e.target.value)}
        style={{ width: 300 }}
      />
      <Button.Group>
        <Button type="dashed" size="small" onClick={clearFilter}>
          Clear filters
        </Button>
        <Button type="dashed" size="small" onClick={clearSort}>
          Clear sorts
        </Button>
      </Button.Group>
    </Row>
  );

  function onSearch(value: string) {
    if (gridApi) gridApi.setQuickFilter(value);
  }

  function clearFilter() {
    if (gridApi) {
      gridApi.setFilterModel(null);
      gridApi.onFilterChanged();
    }
  }

  function clearSort() {
    if (gridApi) {
      gridApi.setSortModel([]);
    }
  }
};
